import type { FC } from "react";

import { SwiperJti, SwiperSlide } from "@ui/components/SwiperJti";
import classnames from "classnames";

import { useDirection } from "@jti/fe-common";

import { ImageGalleryTopic } from "./ImageGalleryTopic";
import type { imageGalleryType } from "./types";

import styles from "./ImageGallery.module.scss";

export type ImageGalleryProps = {
  data: imageGalleryType[];
  mode?: "dark" | "light";
};

export const ImageGallery: FC<ImageGalleryProps> = ({ data, mode = "light" }) => {
  const direction = useDirection();
  const rtl = direction === "rtl";

  const imageGalleryClassNames = classnames(styles.galleryContent, styles.imageGallery, {
    [styles.imageGalleryDark]: mode === "dark",
    [styles.imageGalleryRtl]: rtl,
  });

  return (
    <SwiperJti
      swiperJtiWrapper={styles.imageGalleryWrapper}
      swiperJtiClass={imageGalleryClassNames}
      isShowPaginationButtons={false}
      speed={0}
      autoHeight
      mode={mode}
      rtl={rtl}
      data-testid="image-gallery"
    >
      {data.map((slide) => (
        <SwiperSlide key={`${slide.title}${slide.subtitle}`}>
          <ImageGalleryTopic data={slide} mode={mode} />
        </SwiperSlide>
      ))}
    </SwiperJti>
  );
};
